import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginService } from 'app/view/login/login.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private loginService: LoginService, private router: Router) { }

  canActivate() {
    if (this.loginService.isLogged()) {
      return true;
    }
    this.router.navigate(['/iniciar-sesion']);
    return false;
  }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/services/auth-guard.service.ts